import { isAnyOf } from "@reduxjs/toolkit";

import {
  getBillingLocationsThunk,
  removeBillingLocationsFilter,
  setBillingLocationsFilter,
  setBillingLocationsOrdering,
  setBillingLocationsPagination,
  setBillingLocationsSearch,
} from "../../reducers/billingLocationsReducer";
import { BILLING_PAGE_PATH } from "../routes";
import { startAppListening } from "./listenerMiddleware";
import { resetBillingLocationsList } from "./utils/resetBillingLocationsList";

export const billingLocationsListener = (): void => {
  startAppListening({
    matcher: isAnyOf(
      setBillingLocationsOrdering,
      setBillingLocationsSearch,
      setBillingLocationsFilter,
      removeBillingLocationsFilter
    ),
    effect: async (_, { dispatch }) => {
      const pathname = location.pathname;
      switch (pathname) {
        case BILLING_PAGE_PATH:
          resetBillingLocationsList(dispatch);
          break;
        default:
      }
    },
  });

  startAppListening({
    actionCreator: setBillingLocationsPagination,
    effect: async (_, { dispatch }) => {
      dispatch(getBillingLocationsThunk());
    },
  });
};
